<template>
  <div class="prompt-mode-switch">
    <u-button
      :type="modelValue === 'edit' ? 'primary' : 'default'"
      :data-testid="`${testIdSuffix}-edit-mode-button`"
      @click="select('edit')"
    >
      {{
        $t(
          'components.PromptEditor.FullscreenPromptEditor.5532cd4534c84bda4a68376db2388fa2'
        )
      }}
    </u-button>
    <u-button
      :type="modelValue === 'preview' ? 'primary' : 'default'"
      :data-testid="`${testIdSuffix}-preview-mode-button`"
      @click="select('preview')"
    >
      {{
        $t(
          'components.PromptEditor.FullscreenPromptEditor.2dffa18420ce04ae0579a4e51277d406'
        )
      }}
    </u-button>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

// Shared 编辑 / 预览 segmented switch used by the fullscreen editor and the
// prompt areas that live inside an existing large dialog.
export default defineComponent({
  name: 'PromptModeSwitch',
  props: {
    modelValue: {
      type: String,
      default: 'edit',
      validator: value => ['edit', 'preview'].includes(value)
    },
    testIdSuffix: {
      type: String,
      default: 'prompt-mode'
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const select = mode => {
      if (mode === props.modelValue) return;
      emit('update:modelValue', mode);
    };

    return { select };
  }
});
</script>

<style lang="less" scoped>
.prompt-mode-switch {
  display: inline-flex;
  align-items: center;
  gap: 0;

  // uui drives button padding through this variable and the deep selector sits
  // inside our own class, so other pages keep the global padding.
  :deep(.uui-btn.uui-btn-default-size) {
    --button-padding-base: 0 24px;
    padding: 0 24px;
  }

  // Buttons touch each other, so only the outer corners stay rounded.
  :deep(.uui-btn + .uui-btn) {
    margin-left: -1px;
  }

  :deep(.uui-btn:first-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  :deep(.uui-btn:last-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}
</style>
